/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Preview_Event_LabelInputs */



/**
* | output |
* | --- |
* | "Event" |
*
* @param {Image_Export_Preview_Event_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_preview_event_label = /** @type {((inputs?: Image_Export_Preview_Event_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Preview_Event_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignis")
	if (locale === "it") return /** @type {LocalizedString} */ ("Evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Событие")
	if (locale === "es") return /** @type {LocalizedString} */ ("Evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベント")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आयोजन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Evento")
	return /** @type {LocalizedString} */ ("Event")
});